import { render } from "./JFpurchase.vue?vue&type=template&id=3d9865ad&scoped=true"
import script from "./JFpurchase.vue?vue&type=script&lang=js"
export * from "./JFpurchase.vue?vue&type=script&lang=js"

import "./JFpurchase.vue?vue&type=style&index=0&id=3d9865ad&lang=scss&scoped=true"
import "./JFpurchase.vue?vue&type=style&index=1&id=3d9865ad&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9865ad"]])

export default __exports__